import PaginationData from "@/models/general/PaginationData";
import PlaceMedia from "@/models/places/placesMedias/PlaceMedia";
import PlacesMediasFilter from "@/models/places/placesMedias/PlacesMediasFilter";

export default class PlacesMedias {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.placesMediasData = [];
    this.placeMedia = new PlaceMedia();
    this.filterData = new PlacesMediasFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.pagination);
    this.placesMediasData = data.placesMediaData;
  }
}
